module.exports = __webpack_public_path__ + "static/img/zqys-2.eaf08b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zqys/zqys-2.png
// module id = 232
// module chunks = 6